import "./StagePill.css";
import type { SearchProviderName } from "../types";

type Stage = "understanding" | "searching" | "reading";

const LABELS: Record<Stage, string> = {
  understanding: "Understanding your question…",
  searching: "Searching the web…",
  reading: "Reading sources…",
};

// search-overhaul spec §6 — display names for the "searching" stage's
// per-hop `providers` field.
export const PROVIDER_LABELS: Record<SearchProviderName, string> = {
  searxng: "SearXNG",
  ddgs: "DuckDuckGo",
  tavily: "Tavily",
  brave: "Brave",
  brave_ai: "Brave AI",
  exa: "Exa",
  google_places: "Google Places",
};

function joinNames(names: string[]): string {
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
}

export function searchingLabel(
  providers?: SearchProviderName[] | null,
  execution?: "serial" | "parallel" | null
): string {
  if (!providers || providers.length === 0) return LABELS.searching;
  const names = providers.map((p) => PROVIDER_LABELS[p] ?? p);
  const joined = execution === "parallel" ? joinNames(names) : names[0];
  return `Searching the web with ${joined}…`;
}

export default function StagePill({
  stage,
  providers,
  execution,
}: {
  stage: Stage;
  providers?: SearchProviderName[] | null;
  execution?: "serial" | "parallel" | null;
}) {
  const label = stage === "searching" ? searchingLabel(providers, execution) : LABELS[stage] ?? stage;
  return (
    <div className="stage-pill">
      <span className="stage-pill-spinner" />
      {label}
    </div>
  );
}
